import EmailVerification from './email-verification-container';
import EmailVerificationView from './email-verification-view';

export default EmailVerification;
export { EmailVerificationView };
